import { object, string, array } from 'yup';
import i18n from '../../../i18n';

// Types
import { UserManagement } from './types';

export const UserManagementSchema = object<UserManagement>({
  name: string()
    .trim()
    .required(() => i18n.t('validation:required'))
    .min(1, () => i18n.t('validation:required')),
  surName: string()
    .trim()
    .required(() => i18n.t('validation:required'))
    .min(1, () => i18n.t('validation:required')),
  // CAMBIO: Email condicional según rol
  email: string()
    .trim()
    .email(() => i18n.t('validation:emailValid'))
    .when('rolActive', {
      is: (val: string) => val !== 'operating-team',
      then: (schema) =>
        schema.required(() => i18n.t('validation:emailRequired')),
      otherwise: (schema) => schema.notRequired(),
    }),
  rolActive: string().required(() => i18n.t('validation:required')),
  concession: string().required(() => i18n.t('validation:required')),
  // NUEVO: Equipos (para operarios)
  teamRelationships: array().of(string()),
  state: string(),
});
